import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { Grid } from '@mui/material'

import { NewC2BFormState, NewStaticC2BFormState } from '../../qrs.types.ts'
import { InputNormalizers, TextFieldControl } from '../../../../components/form'

export const StaticQrAmountField = (): React.ReactElement | null => {
  const { watch, resetField } = useFormContext<NewStaticC2BFormState>()
  const amountType = watch('amountType')

  useEffect(() => {
    if (amountType === 'open') {
      resetField('amount')
    }
  }, [amountType])

  if (amountType === 'open') {
    return null
  }

  return (
    <Grid item>
      <TextFieldControl<NewC2BFormState>
        name="amount"
        fullWidth
        normalize={InputNormalizers.positiveNumbersOnly()}
        label="Сумма платежа"
      />
    </Grid>
  )
}
